import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1 m kitchen base unit: 0.6 m deep, 0.9 m high, back
// face flush at z = -0.3 (stands against a wall on the -Z side), warm-white
// door fronts facing +Z and a light-grey worktop with a small front overhang.
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const MATTE_BLACK = "#2e2e30";

export const kitchenCounter = defineModel({
  id: "kitchen-counter",
  batchId: "modern",
  name: "Kitchen counter",
  tags: ["modern", "interior", "furniture", "kitchen", "storage", "counter"],
  summary: "A one-metre kitchen base unit with two door fronts and a worktop.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.94, 0.1, 0.5), color: MATTE_BLACK, position: [0, 0.05, -0.04] },
      // cabinet carcass (back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(1.0, 0.76, 0.56), color: CARCASS, position: [0, 0.48, -0.02] },
      // two door fronts
      { geometry: new THREE.BoxGeometry(0.46, 0.72, 0.02), color: FRONT, position: [-0.245, 0.49, 0.27] },
      { geometry: new THREE.BoxGeometry(0.46, 0.72, 0.02), color: FRONT, position: [0.245, 0.49, 0.27] },
      // thin bar handles
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [-0.245, 0.8, 0.29] },
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [0.245, 0.8, 0.29] },
      // worktop (top surface at 0.9, back flush, small overhang at the front)
      { geometry: new THREE.BoxGeometry(1.0, 0.04, 0.6), color: WORKTOP, position: [0, 0.88, 0] },
    ];
  },
  animations: [],
});
